import cx from "classnames";
import React from "react";
import { Tooltip } from "react-tooltip";

import PartLoader from "@/PartLoader";
import formStyles from "@/styles/form.module.scss";

type PartFormSaveButton = {
  isSubmitting: boolean;
  forceSubmit?: () => Promise<void>;
  children: React.ReactNode;
  className?: string;
};

const PartFormSaveButton: React.FC<PartFormSaveButton> = props => {
  const { isSubmitting, forceSubmit, children, className } = props;
  const id = React.useId();
  return (
    <>
      <Tooltip id={`save-btn-tooltip-${id}`} place="top">
        There are errors in the form
      </Tooltip>
      <button
        type={forceSubmit ? "button" : "submit"}
        className={cx(
          formStyles.buttonSubmit,
          {
            [formStyles.isSubmitting]: isSubmitting,
          },
          className,
        )}
        disabled={isSubmitting}
        data-test-element-type="button"
        data-test-action-type="submit"
        onClick={e => {
          if (forceSubmit) {
            e.preventDefault();
            forceSubmit().then();
          }
        }}
      >
        <PartLoader active={isSubmitting}>{children}</PartLoader>
      </button>
    </>
  );
};

export default PartFormSaveButton;
